// extracted by mini-css-extract-plugin
module.exports = {"colWrap":"creditDetails_colWrap__3Ylor","borderRight":"creditDetails_borderRight__4QlK_","coltitle":"creditDetails_coltitle__5PhIA","label":"creditDetails_label__2hUug"};